module.exports = __webpack_public_path__ + "img/weizuoda.9015eb1f.png";